import { ReactNode } from 'react';

export type CodTipoTranscricao = 'NORMAL' | 'BUCO' | 'TERESP';

export interface TipoAtendimentoOption {
  codigo: CodTipoTranscricao;
  label: string;
  tooltip: ReactNode;
}

const TOOLTIP_NORMAL = (
  <>
    <p style={{ margin: '0 0 12px' }}>
      <strong>Exames:</strong> Procedimentos diagnósticos laboratoriais ou de imagem utilizados
      para identificar, monitorar ou prevenir doenças através da análise de amostras biológicas
      (sangue, urina) ou visualização de órgãos.
    </p>
    <p style={{ margin: '0 0 12px' }}>
      <strong>Procedimentos:</strong> Intervenções assistenciais, terapêuticas ou cirúrgicas
      realizadas por profissionais de saúde para tratamento, diagnóstico ou reabilitação do paciente.
    </p>
    <p style={{ margin: '0 0 12px' }}>
      <strong>Materiais:</strong> Itens médico-hospitalares, como seringas, curativos e equipamentos,
      utilizados na prestação de assistência direta, na realização de procedimentos ou na segurança do paciente.
    </p>
    <p style={{ margin: 0 }}>
      <strong>Medicamentos:</strong> Substâncias químicas utilizadas para prevenir, curar, aliviar
      sintomas ou diagnosticar doenças, administradas por diversas vias (oral, intravenosa, etc.).
    </p>
  </>
);

export const TIPO_ATENDIMENTO_OPCOES: TipoAtendimentoOption[] = [
  {
    codigo: 'NORMAL',
    label: 'Cirurgias, Exames, Materiais ou Medicamentos',
    tooltip: TOOLTIP_NORMAL,
  },
  {
    codigo: 'BUCO',
    label: 'Buco Maxilo Facial',
    tooltip: 'Especialidade da odontologia que diagnostica e trata cirurgicamente doenças, lesões e deformidades na boca, maxilares e região facial, incluindo fraturas, tumores e cirurgias ortognáticas.',
  },
  {
    codigo: 'TERESP',
    label: 'Terapias Especiais',
    tooltip: 'As Terapias Especiais (ou tratamentos de alta complexidade/especializados) referem-se a um conjunto de abordagens terapêuticas personalizadas, destinadas a atender necessidades específicas de pacientes com condições crônicas, deficiências, distúrbios de desenvolvimento ou necessidades funcionais complexas. Diferente das terapias convencionais, elas focam na máxima autonomia e reabilitação, exigindo frequentemente uma equipe multidisciplinar e técnicas especializadas.',
  },
];

export const isCodTipoTranscricaoValido = (codigo?: string | null): codigo is CodTipoTranscricao =>
  TIPO_ATENDIMENTO_OPCOES.some((option) => option.codigo === codigo?.trim().toUpperCase());

export const isCodTipoTranscricaoPreenchido = (codigo?: string | null): boolean =>
  isCodTipoTranscricaoValido(codigo);

export const normalizeCodTipoTranscricao = (codigo?: string | null): CodTipoTranscricao | '' => {
  if (!codigo?.trim()) return '';

  const normalized = codigo.trim().toUpperCase();
  return isCodTipoTranscricaoValido(normalized) ? normalized : '';
};
